var map = {
	"./Ck.svg": 60219,
	"./Finance.svg": 41565,
	"./Goods.svg": 94657,
	"./Kc.svg": 92939,
	"./Performance.svg": 97741,
	"./Print.svg": 86990,
	"./Room.svg": 68292,
	"./Setting.svg": 21171,
	"./Staff.svg": 9821,
	"./VIP.svg": 76946,
	"./Wechat.svg": 72975,
	"./Wx.svg": 1020,
	"./dashboard.svg": 4679,
	"./message.svg": 38166
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;